import { z } from 'zod';
/**
 * Конфигурация печатной формы «Поручение экспедитору» — состав и порядок строк
 * основной таблицы бланка. Редактируется админом.
 *
 * Строка одного из двух видов:
 *  - `ref`    — ссылка на предустановленную строку реестра (key); можно вкл/выкл
 *               и переопределить подпись (label).
 *  - `custom` — своя строка админа: подпись + значение, где значение может
 *               содержать токены `{{поле}}` из белого списка (подставляются из
 *               данных поручения при печати).
 */
export const poruchenieRefRowSchema = z.object({
    kind: z.literal('ref'),
    /** Ключ строки из реестра PORUCHENIE_ROWS. */
    key: z.string().min(1).max(80),
    enabled: z.boolean(),
    /** Переопределение подписи (пусто/undefined — берётся подпись по умолчанию). */
    label: z.string().max(200).optional(),
    /** Печатать строку, даже если её значение пустое (по умолчанию — да). */
    showWhenEmpty: z.boolean().default(true),
});
export const poruchenieCustomRowSchema = z.object({
    kind: z.literal('custom'),
    /** Стабильный id строки (генерируется на клиенте). */
    id: z.string().min(1).max(80),
    enabled: z.boolean(),
    label: z.string().max(200),
    /** Значение; поддерживает токены `{{cargoVolumeM3}}` и т.п. */
    value: z.string().max(2000),
    /** Печатать строку, даже если её значение пустое (по умолчанию — да). */
    showWhenEmpty: z.boolean().default(true),
});
export const poruchenieRowSchema = z.discriminatedUnion('kind', [
    poruchenieRefRowSchema,
    poruchenieCustomRowSchema,
]);
/** DTO сохранения конфигурации (PUT). */
export const poruchenieTemplateInputSchema = z.object({
    rows: z.array(poruchenieRowSchema).max(100),
});
//# sourceMappingURL=poruchenie-template.js.map